import styled from 'styled-components'
import { tokens } from '../../styles/tokens'

interface Props {
  title: string
}

const Eyebrow = styled.p`
  font-size: 10px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${tokens.purple400};
  margin-bottom: 8px;
`

const PageTitle = styled.h1`
  font-family: 'Cormorant Garamond', serif;
  font-size: 40px;
  font-weight: 300;
  color: ${tokens.purple900};
  letter-spacing: -0.5px;
`

export function CatalogPage({ title }: Props) {
  return (
    <>
      <Eyebrow>Catalog</Eyebrow>
      <PageTitle>{title}</PageTitle>
    </>
  )
}
